module.exports = __webpack_public_path__ + "img/discount.69fa091.png";